import { render, staticRenderFns } from "./chatWidget.vue?vue&type=template&id=bcc40e2e"
import script from "./chatWidget.vue?vue&type=script&lang=js"
export * from "./chatWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports